import { useQuery } from '@tanstack/react-query';
import FarmAddressApi from '../apis/farm_address_api';

export const farmKeys = {
  all: ['farms'],
  list: (search: string) => [...farmKeys.all, 'list', search],
  detail: (farmId: number) => [...farmKeys.all, 'detail', farmId],
};

export function useFarms(search: string) {
  return useQuery({
    queryKey: farmKeys.list(search),
    queryFn: async () => FarmAddressApi.getFarmsForUser(search),
  });
}

export function useFarm(farmId: number) {
  return useQuery({
    queryKey: farmKeys.detail(farmId),
    queryFn: async () => FarmAddressApi.getFarm(farmId),
    enabled: !!farmId,
  });
}
